export default __webpack_public_path__ + "static/media/volkswagen.fc1f246c.svg";